import { SupportedLocale } from '@src/cnst/translations.cnst'
import { NcLink } from '@src/components/nc-link/NcLink.component'
import { languageContext } from '@src/context/language.context'
import { useAppSelector } from '@src/hooks/useAppSelector'
import { GeolocationCountry, selectGeolocation } from '@src/store/geolocation/geolocation.slice'
import { ReactNode, useContext } from 'react'
import { FsaBadge } from '../fsa-badge/FsaBadge.component'
import styles from './HeroBadge.module.scss'

interface HeroBadgeProps {
  rating: string
  store: string
  context: string
}

export function HeroBadge({ rating, store, context }: HeroBadgeProps): ReactNode {
  const starIconUrl = '/icons/star-rounded.svg'

  const { locale } = useContext(languageContext)
  const { country } = useAppSelector(selectGeolocation)

  const link = {
    [SupportedLocale.svSE]: '/sv/reviews',
    [SupportedLocale.enUS]: '/reviews',
    [SupportedLocale.ptBR]: '/pt-br/reviews',
    [SupportedLocale.esUS]: '/es/reviews',
    [SupportedLocale.enCA]: '/reviews',
  }

  return (
    <div className={styles.HeroBadge}>
      <NcLink className={styles.HeroBadge__appStore} to={link[locale]}>
        <div className={styles.HeroBadge__appStore__upperRow}>
          <span className={styles.HeroBadge__appStore__rating}>{rating}</span>
          <img src={starIconUrl} className={styles.HeroBadge__appStore__starIcon} alt="star icon" />
          <span className={styles.HeroBadge__appStore__appStore}>{store}</span>
        </div>
        <div className={styles.HeroBadge__appStore__lowerRow}>
          <span className={styles.HeroBadge__appStore__ratingCount}>{context}</span>
        </div>
      </NcLink>
      {country === GeolocationCountry.US && <FsaBadge hasBlueTick />}
    </div>
  )
}
